/* eslint-disable react/display-name */
import React from 'react'

//
import {
  Block2ColumnsIntegrationList,
  BlockBenefitsListing,
  BlockBlogTop,
  BlockCrissCross,
  BlockCta,
  BlockCustomersTop,
  BlockFaqTop,
  BlockFeatureContact,
  BlockFeatureSimple,
  BlockFeatureList,
  BlockFilter,
  BlockHero,
  BlockHeroDual,
  BlockHeroHome,
  BlockHeroHomeTwo,
  BlockHubSpotCalendar,
  BlockIntegrationListing,
  BlockLogos,
  BlockOffices,
  BlockPricingCards,
  BlockRelatedArticles,
  BlockRequestForm,
  BlockRichText,
  BlockSectionHeader,
  BlockSpotlight,
  BlockSummary,
  BlockTeamMembers,
  BlockTwoBlocksBanner,
  BlockUspList,
  BlockWistiaVideo,
  Block3CardsWithImage
} from '../components'

const storybookComponents = {
  Block2BlocksBannerModelRecord: (props) => <BlockTwoBlocksBanner data={props} />,
  Block2ColumnsIntegrationListModelRecord: (props) => <Block2ColumnsIntegrationList data={props} />,
  BlockBenefitsListingModelRecord: (props) => <BlockBenefitsListing data={props} />,
  BlockBlogTopModelRecord: (props) => <BlockBlogTop data={props} />,
  BlockCrissCrossModelRecord: (props) => <BlockCrissCross data={props} />,
  BlockCtaModelRecord: (props) => <BlockCta data={props} />,
  BlockCustomersTopModelRecord: (props) => <BlockCustomersTop data={props} />,
  BlockFAQTopModelRecord: (props) => <BlockFaqTop data={props} />,
  BlockFeatureContactModelRecord: (props) => <BlockFeatureContact data={props} />,
  BlockFeatureSimpleModelRecord: (props) => <BlockFeatureSimple data={props} />,
  BlockFeatureListModelRecord: (props) => <BlockFeatureList data={props} />,
  BlockHeroModelRecord: (props) => <BlockHero data={props} />,
  BlockHeroHomeModelRecord: (props) => <BlockHeroHome data={props} />,
  BlockHeroHomeTwoModelRecord: (props) => <BlockHeroHomeTwo data={props} />,
  BlockIntegrationListingModelRecord: (props) => <BlockIntegrationListing data={props} />,
  BlockIntegrationsFilteringModelRecord: (props) => <BlockFilter data={props} />,
  BlockLogosModelRecord: (props) => <BlockLogos data={props} />,
  Block3CardsWithImageModelRecord: (props) => <Block3CardsWithImage data={props} />,
  BlockThreeColumnCardRecord: (props) => <BlockOffices data={props} />,
  BlockPricingCardsModelRecord: (props) => <BlockPricingCards data={props} />,
  BlockRequestFormModelRecord: (props) => <BlockRequestForm data={props} />,
  BlockRelatedArticlesModelRecord: (props) => <BlockRelatedArticles data={props} />,
  BlockRichTextModelRecord: (props) => <BlockRichText data={props} />,
  BlockSectionHeaderModelRecord: (props) => <BlockSectionHeader data={props} />,
  BlockSpotlightModelRecord: (props) => <BlockSpotlight data={props} />,
  BlockSummaryModelRecord: (props) => <BlockSummary data={props} />,
  BlockTeamMembersModelRecord: (props) => <BlockTeamMembers data={props} />,
  BlockUspListModelRecord: (props) => <BlockUspList data={props} />,
  BlockWatchADemoModelRecord: (props) => <BlockWistiaVideo data={props} />,
  BlockHeroDualModelRecord: (props) => <BlockHeroDual data={props} />,
  HubSpotCalendarModelRecord: (props) => <BlockHubSpotCalendar data={props} />
}

export const renderComponent = ({ component, extra, idx = 0 }) => {
  if (!component?.__typename || !component?.id || !storybookComponents[component.__typename]) {
    return null
  }

  const Comp = storybookComponents[component.__typename]

  return <Comp key={`comp-${idx}=${component.id}`} {...component} extra={extra} />
}
